import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import Form, { SimpleItem, GroupItem, ColCountByScreen } from 'devextreme-react/form';

import SelectBox from 'devextreme-react/select-box';
import TextArea from 'devextreme-react/text-area';

import { FormTextbox } from '../../utils/form-textbox/FormTextbox';
import { FormDateBox } from '../../utils/form-datebox/FormDateBox';

import { PRIORITY_ITEMS, STATUS_ITEMS } from '../../../shared/constants';
import { editFieldRender, statusItemRender, priorityFieldRender, priorityItemRender } from '../../../shared/statusIndicatorRenderMethods';

import { Task } from '../../../types/task';
import './TaskFormDetails.scss';
import { getSizeQualifier } from '../../../utils/media-query';

export const TaskFormDetails = ({ editing, data, subjectField, onDataChanged }: {
  editing: boolean, data: Task, subjectField: boolean, onDataChanged: (data) => void
}) => {
  const [formData, setFormData] = useState<Task>({ ...data });

  useEffect(() => {
    setFormData({ ...data });
  }, [data]);

  const updateField = (field: string) => (value: string | Date | number | null) => {
    const newData = { ...formData, [field]: value };
    onDataChanged(newData);

    setFormData(newData);
  };

  return (
    <Form
      className={classNames({ 'plain-styled-form task-form-details': true, 'view-mode': !editing })}
      screenByWidth={getSizeQualifier}
    >
      {subjectField && <SimpleItem colSpan={2}>
        <FormTextbox
          label='Subject'
          value={formData.text}
          isEditing={!editing}
          onValueChange={updateField('text')}
        />
      </SimpleItem>}
      <GroupItem itemType='group'>
        <ColCountByScreen xs={1} sm={2} md={2} lg={2} />
        <SimpleItem cssClass='accent'>
          <div className='task-detail-field'>
            <label>Company</label>
            <FormTextbox
              value={formData.company}
              isEditing={!editing}
              stylingMode='outlined'
              onValueChange={updateField('company')}
            />
          </div>
        </SimpleItem>
        <SimpleItem cssClass='accent'>
          <div className='task-detail-field'>
            <label>Assigned to</label>
            <FormTextbox
              value={formData.owner}
              isEditing={!editing}
              stylingMode='outlined'
              onValueChange={updateField('owner')}
            />
          </div>
        </SimpleItem>
        <SimpleItem>
          <div className='task-detail-field'>
            <label>Priority</label>
            <SelectBox
              value={formData.priority}
              items={PRIORITY_ITEMS}
              readOnly={!editing}
              stylingMode='outlined'
              fieldRender={priorityFieldRender}
              itemRender={priorityItemRender}
              onValueChange={updateField('priority')}
            />
          </div>
        </SimpleItem>
        <SimpleItem>
          <div className='task-detail-field'>
            <label>Status</label>
            <SelectBox
              value={formData.status}
              items={STATUS_ITEMS}
              readOnly={!editing}
              stylingMode='outlined'
              fieldRender={editFieldRender}
              itemRender={statusItemRender}
              onValueChange={updateField('status')}
            />
          </div>
        </SimpleItem>
        <SimpleItem>
          <div className='task-detail-field'>
            <label>Start Date</label>
            <FormDateBox
              value={formData.startDate}
              readOnly={!editing}
              name='Set Start Date'
              stylingMode='outlined'
              onValueChange={updateField('startDate')}
            />
          </div>
        </SimpleItem>
        <SimpleItem>
          <div className='task-detail-field'>
            <label>Due Date</label>
            <FormDateBox
              value={formData.dueDate}
              readOnly={!editing}
              name='Set Due Date'
              stylingMode='outlined'
              onValueChange={updateField('dueDate')}
            />
          </div>
        </SimpleItem>
      </GroupItem>

      <SimpleItem colSpan={2} cssClass='task-description-item'>
        <div className='task-detail-field task-detail-field-description'>
          <label>Details</label>
          <TextArea
            readOnly={!editing}
            value={formData.description}
            stylingMode='outlined'
            onValueChange={updateField('description')}
          />
        </div>
      </SimpleItem>
    </Form>
  );
};
